/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { ChangeEventHandler, KeyboardEventHandler, ReactNode, useState } from 'react';
import { Control, useController } from 'react-hook-form';

import { Flex } from '@/lib/v2/components/Layout/Stack';

import { IContactFormCustomField } from '@/src/ContactsModule/interfaces/CustomFieldsInterfaces';

export type InputProps = {
  id?: string;
  title?: string;
  value?: string;
  keyDownEnter?: KeyboardEventHandler;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  flatInput?: boolean;
  name: string;
  control: Control<any>;
  error?: string;
  children?: ReactNode;
  itemList?: '' | IContactFormCustomField[] | null;
  multiple?: boolean;
};

export const SelectForm = React.forwardRef<HTMLSelectElement, InputProps>((props, ref) => {
  const { id, title, keyDownEnter, onChange, flatInput, error, itemList, multiple } = props;

  const [onblur, setOnblur] = useState(false);
  const { field, fieldState } = useController(props);

  return (
    <>
      {itemList && (
        <Flex column itemAlignment="start">
          <div className="pl-4 text-12 text-[#949FAD]">{title}</div>
          <div className="relative w-full grow">
            <select
              {...field}
              {...fieldState}
              ref={ref}
              className={
                flatInput
                  ? 'h-9 w-full px-4 py-1 text-12 leading-5 disabled:bg-inherit lg:text-12 xl:text-14 2xl:text-14'
                  : `h-9 w-full border  px-4 py-1 text-12 leading-5 placeholder:text-gray-500 hover:rounded-md hover:bg-[#F9FAFB] hover:outline-none hover:placeholder:text-gray-400 focus:bg-[#FFF] focus:outline-none lg:text-12 xl:text-14 2xl:text-14${
                      error
                        ? 'border-b-2 border-red-500 bg-slate-100 text-red-500 hover:border-red-500'
                        : ''
                    }
                            ${multiple && 'h-24'}
                            ${
                              !error && !flatInput && onblur
                                ? 'rounded-md border border-slate-300 bg-[#F9FAFB]'
                                : !error && !flatInput
                                ? 'rounded-md border border-slate-300 bg-[#F9FAFB]'
                                : ''
                            }
                            `
              }
              disabled={flatInput}
              id={id}
              multiple={multiple}
              value={field.value}
              onBlur={() => setOnblur(!onblur)}
              onChange={onChange}
              onFocus={() => setOnblur(!onblur)}
              onKeyDown={keyDownEnter}
            >
              {props.children}
              {itemList &&
                itemList?.map((item: IContactFormCustomField) => {
                  return (
                    <option key={item.id} selected value={item.id}>
                      {item.value}
                    </option>
                  );
                })}
              ;
            </select>
            {fieldState.isDirty}
            <div>{error && <div className="absolute text-12 text-red-500">{error}</div>}</div>
          </div>
        </Flex>
      )}
    </>
  );
});
